import { useEffect, useCallback } from "react";

/**
 * Custom hook for managing page titles
 * @param title - The page title
 * @param siteName - The site name (default: 'Tukera')
 */
export function usePageTitle(title: string, siteName: string = "Tukera"): void {
  const setDocumentTitle = useCallback((newTitle: string) => {
    document.title = newTitle;
  }, []);

  useEffect(() => {
    const fullTitle = title ? `${title} | ${siteName}` : siteName;
    setDocumentTitle(fullTitle);

    // Cleanup function to reset title on unmount
    return () => {
      setDocumentTitle(siteName);
    };
  }, [title, siteName, setDocumentTitle]);
}

export default usePageTitle;
